import { render, staticRenderFns } from "./GroupMemberSecurityEditDialog.vue?vue&type=template&id=ed5bb8fe&scoped=true"
import script from "./GroupMemberSecurityEditDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberSecurityEditDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberSecurityEditDialog.vue?vue&type=style&index=0&id=ed5bb8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bb8fe",
  null
  
)

export default component.exports